import React from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import NumberFormat from 'react-number-format';
import CurrencyInput from 'react-currency-input';
import GeneralParams from '../../app/server/generalParams';
import { updateGeneralParams } from '../../app/store/actions/generalParams';
import FIELDS from '../../data/fields';


class GeneralComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      success: '',
      userLoggedOutSeesStock: false,
      userLoggedInSeesStock: false,
      sendEmailAbandoned: false,
      couponDueDaysForNewUser: 0,
      discountPercentageForNewUserCoupon: 0,
      minimumValueForNewUserCoupon: 0,
      maximumValueForNewUserCoupon: 0,
      dateInicialToGenerateCoupon: 0,
      dateFinalToGenerateCoupon: 0,
      financialEmails: '',
    };
  }

  async componentDidMount() {
    await this.getGeneralParams();
  }

  async getGeneralParams() {
    const params = await GeneralParams.getGeneralParams();
    this.setParamsUpdate(params);
  }

  setParamsUpdate = async (item) => {
    const {
      userLoggedOutSeesStock,
      userLoggedInSeesStock,
      sendEmailAbandoned,
      couponDueDaysForNewUser,
      discountPercentageForNewUserCoupon,
      minimumValueForNewUserCoupon,
      maximumValueForNewUserCoupon,
      dateInicialToGenerateCoupon,
      dateFinalToGenerateCoupon,
      financialEmails,
    } = item;

    await this.setState({
      userLoggedOutSeesStock,
      userLoggedInSeesStock,
      sendEmailAbandoned,
      couponDueDaysForNewUser,
      discountPercentageForNewUserCoupon,
      minimumValueForNewUserCoupon,
      maximumValueForNewUserCoupon,
      dateInicialToGenerateCoupon,
      dateFinalToGenerateCoupon,
      financialEmails: financialEmails || '',
      message: '',
    });
  }

  selectedItem = (attr, value) => {
    this.setState({ [attr]: value.target.value, message: '', success: '' });
  }

  selectCheckItem = (props) => {
    this.setState(prevState => ({ [props]: !prevState[props] }));
  };

  saveDataGeneral = async () => {
    const {
      userLoggedOutSeesStock,
      userLoggedInSeesStock,
      sendEmailAbandoned,
      couponDueDaysForNewUser,
      discountPercentageForNewUserCoupon,
      minimumValueForNewUserCoupon,
      maximumValueForNewUserCoupon,
      dateInicialToGenerateCoupon,
      dateFinalToGenerateCoupon,
      financialEmails,
    } = this.state;

    const generalProps = {
      userLoggedOutSeesStock,
      userLoggedInSeesStock,
      sendEmailAbandoned,
      couponDueDaysForNewUser,
      discountPercentageForNewUserCoupon,
      minimumValueForNewUserCoupon,
      maximumValueForNewUserCoupon,
      dateInicialToGenerateCoupon: Number(dateInicialToGenerateCoupon),
      dateFinalToGenerateCoupon: Number(dateFinalToGenerateCoupon),
      financialEmails,
    };

    try {
      await this.props.updateGeneralParams(generalProps);
      this.setState({ success: I18n.t('successActualized'), message: '' });
      await this.getGeneralParams();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;

      if (error && error.code === 1616) {
        this.setState({ message: I18n.t('errorUpdatingGeneralParams'), success: '' });
      } else {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
  }

  render() {
    const {
      message,
      success,
      userLoggedOutSeesStock,
      userLoggedInSeesStock,
      sendEmailAbandoned,
      couponDueDaysForNewUser,
      discountPercentageForNewUserCoupon,
      minimumValueForNewUserCoupon,
      maximumValueForNewUserCoupon,
      dateInicialToGenerateCoupon,
      dateFinalToGenerateCoupon,
      financialEmails,
    } = this.state;

    return (
      <div>
        <div className="row margin-bottom-20" style={{ marginTop: 10 }}>
          <div className="col-6">
            <div id="checkboxs">
              <h1 style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
              }}
              >
                {I18n.t('financialSettings')}
              </h1>

              <div className="form-group">
                <p className="margin-bottom-2">
                  <Translate value="financialEmails" />
                </p>
                <textarea
                  value={financialEmails}
                  onChange={e => this.selectedItem('financialEmails', e)}
                  className="form-control"
                  placeholder={I18n.t('separateBySemicolon')}
                  rows="3"
                  maxLength={FIELDS.max}
                />
              </div>
            </div>

            <div id="checkboxs">
              <h1 style={{
                fontSize: '20px',
                fontWeight: 'bold',
              }}
              >
                {I18n.t('visualizeStock')}
              </h1>

              <div className="form-check">
                <div>
                  <input
                    onClick={() => this.selectCheckItem('userLoggedOutSeesStock')}
                    type="checkbox"
                    className="form-check-input"
                    checked={userLoggedOutSeesStock}
                    id="userLoggedOutSeesStock"
                  />
                  <p className="permission-text">
                    {I18n.t('userLoggedOutSeesStock')}
                  </p>
                </div>

                <div>
                  <input
                    onClick={() => this.selectCheckItem('userLoggedInSeesStock')}
                    type="checkbox"
                    className="form-check-input"
                    checked={userLoggedInSeesStock}
                    id="userLoggedInSeesStock"
                  />
                  <p className="permission-text">
                    {I18n.t('userLoggedInSeesStock')}
                  </p>
                </div>
              </div>
            </div>

            <div id="checkboxs">
              <h1
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                }}
              >
                {I18n.t('couponDiscountForNewUser')}
              </h1>

              <div>
                <div id="dateInicialToGenerateCoupon">
                  <p className="margin-bottom-2">
                    <Translate value="dateInicialToGenerateCoupon" />
                  </p>
                  <p>
                    <NumberFormat
                      className="limit-input"
                      value={Number(dateInicialToGenerateCoupon)}
                      onChange={e => this.setValue('dateInicialToGenerateCoupon', e.target.value)}
                      disabled={!sendEmailAbandoned}
                    />
                  </p>
                </div>
                <div id="dateFinalToGenerateCoupon">
                  <p className="margin-bottom-2">
                    <Translate value="dateFinalToGenerateCoupon" />
                  </p>
                  <p>
                    <NumberFormat
                      className="limit-input"
                      value={Number(dateFinalToGenerateCoupon)}
                      onChange={e => this.setValue('dateFinalToGenerateCoupon', e.target.value)}
                      disabled={!sendEmailAbandoned}
                    />
                  </p>
                </div>
                <div id="couponDueDaysForNewUser">
                  <p className="margin-bottom-2">
                    <Translate value="couponDueDaysForNewUser" />
                  </p>
                  <p>
                    <NumberFormat
                      className="limit-input"
                      value={Number(couponDueDaysForNewUser)}
                      onChange={e => this.setValue('couponDueDaysForNewUser', e.target.value)}
                      disabled={!sendEmailAbandoned}
                    />
                  </p>
                </div>
                <div id="discountPercentageForNewUserCoupon">
                  <p className="margin-bottom-2">
                    <Translate value="discountPercentageForNewUserCoupon" />
                  </p>
                  <p>
                    <input
                      type="text"
                      value={Number(discountPercentageForNewUserCoupon)}
                      className="limit-input"
                      onChange={e => this.setValue('discountPercentageForNewUserCoupon', Number(e.target.value) || 0)
                }
                      maxLength={FIELDS.percentage}
                    />
                  </p>
                </div>
                <div id="minimumValueForNewUserCoupon">
                  <p className="margin-bottom-2">
                    <Translate value="minimumValueForNewUserCoupon" />
                  </p>
                  <p>
                    <CurrencyInput
                      decimalSeparator=","
                      thousandSeparator=""
                      value={minimumValueForNewUserCoupon}
                      className="limit-input"
                      onChangeEvent={e => this.setValue('minimumValueForNewUserCoupon', e.target.value)}
                      maxLength={FIELDS.float_max}
                    />
                  </p>
                </div>
                <div id="maximumValueForNewUserCoupon">
                  <p className="margin-bottom-2">
                    <Translate value="maximumValueForNewUserCoupon" />
                  </p>
                  <p>
                    <CurrencyInput
                      decimalSeparator=","
                      thousandSeparator=""
                      value={maximumValueForNewUserCoupon}
                      className="limit-input"
                      onChangeEvent={e => this.setValue('maximumValueForNewUserCoupon', e.target.value)}
                      maxLength={FIELDS.float_max}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={() => this.saveDataGeneral()}
          type="button"
          className="btn btn-secondary margin-bottom-20"
        >
          <Translate value="save" />
        </button>
        {success && <p className="color-green margin-top-10">{success}</p>}
        {message && <p className="color-red margin-top-10">{message}</p>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = dispatch => ({
  updateGeneralParams: params => dispatch(updateGeneralParams(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralComponent);
